import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
var CLASSNAME = 'Icons-logout';
var ID = 'icon-logout';
/* eslint-disable max-len */

var SVGLogout = function SVGLogout() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 20 12"
  }, React.createElement("g", null, React.createElement("path", {
    d: "M13.453771,9.7246016 C13.4485272,9.71673592 13.4432834,9.70887025 13.4354178,9.70100457 L10.0269567,9.70100457 C9.41343371,9.70100457 8.91527402,9.20284487 8.91527402,8.58669999 L8.91527402,7.29148478 C8.71076635,7.23642503 8.49839301,7.18660906 8.27553209,7.14728066 C8.7291196,6.66223043 9.0725876,5.90188143 9.42654318,5.00257208 C9.63105084,4.48343725 9.59434434,4.03771541 9.59434434,3.40583917 C9.59434434,2.93914219 9.6834887,2.18928076 9.5681254,1.77764354 C9.17484144,0.38541829 8.18900962,0 7.03013286,0 C5.8712561,0 4.88280239,0.38541829 4.49214031,1.78026543 C4.37677702,2.19190265 4.46592138,2.93914219 4.46592138,3.40583917 C4.46592138,4.04033731 4.42921488,4.48605914 4.63634443,5.00781587 C4.99030001,5.912369 5.32852422,6.67009611 5.78211173,7.15252445 C4.02282144,7.4750173 2.83510386,8.3926799 2.03280456,8.75187925 C0.373146212,9.49125312 0.365280532,10.3014181 0.365280532,10.3014181 L0.365280532,11.6752901 L13.453771,11.6752901 L13.453771,11.6700463 L13.453771,9.7246016",
    id: "Fill-755"
  }), React.createElement("path", {
    d: "M14.607404,3.67065038 L14.607404,6.75399669 L10.0662851,6.75399669 L10.0662851,8.80693901 L14.607404,8.80693901 L14.607404,11.8902853 L19.3608962,7.7791569 L14.607404,3.67065038 Z",
    id: "Fill-756"
  })));
};
/* eslint-disable max-len */


var Logout = function Logout(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGLogout
  });
};

Logout.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default Logout;